import { render } from "./ControlloPagamenti.vue?vue&type=template&id=5ef878c4"
import script from "./ControlloPagamenti.vue?vue&type=script&lang=js"
export * from "./ControlloPagamenti.vue?vue&type=script&lang=js"

import "./ControlloPagamenti.vue?vue&type=style&index=0&id=5ef878c4&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__